import {
  type RefObject,
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";

const STICK_THRESHOLD_PX = 48;

export const useStickToBottom = (
  scrollerRef: RefObject<HTMLElement>,
): { stuck: boolean; scrollToBottom: () => void } => {
  const stuckRef = useRef(true);
  const [stuck, setStuck] = useState(true);

  const scrollToBottom = useCallback(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    scroller.scrollTop = scroller.scrollHeight;
    stuckRef.current = true;
    setStuck(true);
  }, [scrollerRef]);

  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const onScroll = () => {
      const distanceFromBottom =
        scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight;
      const next = distanceFromBottom <= STICK_THRESHOLD_PX;
      if (next === stuckRef.current) return;
      stuckRef.current = next;
      setStuck(next);
    };
    scroller.addEventListener("scroll", onScroll, { passive: true });
    return () => scroller.removeEventListener("scroll", onScroll);
  }, [scrollerRef]);

  // No dependency array on purpose: adding one stops the scroller following
  // text that streams in between renders.
  useLayoutEffect(() => {
    if (!stuckRef.current) return;
    const scroller = scrollerRef.current;
    if (!scroller) return;
    scroller.scrollTop = scroller.scrollHeight;
  });

  return { stuck, scrollToBottom };
};
